import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const LightNumber = ({ lightnumber }: SpecProps<"lightnumber">) => {
  const { i18n } = useLingui();

  if (lightnumber == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.lightNumber",
    message: "Light number",
    comment: "Field for the number of lights on a boat in ad specification",
  });
  return <FieldValuePair field={field} value={lightnumber} />;
};
